import { CNFlag } from "@/components/icons/flags/CNFlag";
import { USFlag } from "@/components/icons/flags/USFlag";
import { ILFlag } from "@/components/icons/flags/ILFlag.tsx";
import { ESFlag } from "@/components/icons/flags/ESFlag";
import { CNFlagRound } from "@/components/icons/flags/CNFlagRound";
import { ILFlagRound } from "@/components/icons/flags/ILFlagRound.tsx";
import { ESFlagRound } from "@/components/icons/flags/ESFlagRound";
import { USFlagRound } from "@/components/icons/flags/USFlagRound";
import { DEFlag } from "@/components/icons/flags/DEFlag.tsx";
import { DEFlagRound } from "@/components/icons/flags/DEFlagRound.tsx";
import { PTFlag } from "@/components/icons/flags/PTFlag.tsx";
import { PTFlagRound } from "@/components/icons/flags/PTFlagRound.tsx";

const languageMenu = [
  {
    id: "fr",
    name: "Français",
    shortName: "Fra",
    value: "fr",
    icon: <CNFlag width="20px" height="20px" />,
    iconMobile: <CNFlagRound />,
  },
  {
    id: "en",
    name: "English",
    shortName: "Eng",
    value: "en",
    icon: <USFlag width="20px" height="20px" />,
    iconMobile: <USFlagRound />,
  },
  {
    id: "it",
    name: "Italiano",
    shortName: "Ita",
    value: "it",
    icon: <ILFlag width="20px" height="20px" />,
    iconMobile: <ILFlagRound />,
  },
  {
    id: "es",
    name: "Español",
    shortName: "Esp",
    value: "es",
    icon: <ESFlag width="20px" height="20px" />,
    iconMobile: <ESFlagRound />,
  },
  {
    id: "de",
    name: "Deutsch",
    shortName: "Deu",
    value: "de",
    icon: <DEFlag width="20px" height="20px" />,
    iconMobile: <DEFlagRound />,
  },
  {
    id: "pt",
    name: "Português",
    shortName: "Por",
    value: "pt",
    icon: <PTFlag width="20px" height="20px" />,
    iconMobile: <PTFlagRound />,
  },
];

export default languageMenu;
